import { TAccountDiscountInfoType } from '@boss/services/client';

type DiscountInfo = {
  [key: string]: {
    code: TAccountDiscountInfoType;
    rgb: string;
  };
};

export const DISCOUNT_TYPES: DiscountInfo = {
  DEFAULT: {
    code: '1',
    rgb: '#226E55',
  },
  SPECIFIC: {
    code: '2',
    rgb: '#B74433',
  },
  WORKSITE: {
    code: '3',
    rgb: '#7FACC6',
  },
};
